import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrCurrency.ts
var t = () => e("currency");
//#endregion
export { t as useTrCurrency };
